import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import { CubeRoleGroup } from "./CubeRoleGroup";
import ListSearch from "../bucket/ListSearch";
import { CubeQueryWizard } from "./CubeQueryWizard/CubeQueryWizard";
import { StoreContext } from "../../contexts/StoreContext";
import { DATAMODELS_TYPES } from "src/constants/constants-container";

@inject("detailViewStore", "exportImportStore", "previewStore")
@observer
export class CubeRepresentation extends React.Component {
  componentDidMount() {
    this.context.setSearchMatrix(this.props.searchMatrixKey, "");
    const {
      openFromCubeLinkPage,
      toggleShowQueryWizard,
      toggleOpenFromCubeLinkPage,
      populateDefaultFiltersFromMemberLinks,
    } = this.props.cubeQueryWizardStore;

    if (openFromCubeLinkPage) {
      toggleShowQueryWizard(true, true);
      populateDefaultFiltersFromMemberLinks();
      toggleOpenFromCubeLinkPage(false);
    }
  }

  helper_findCubeStructure(item) {
    if (item.object.type === "CubeStructure") {
      return item;
    } else {
      if (item.items)
        // check if cube structure exists, it can happen it does not if validity ranges are not valid
        for (let i = 0; i < item.items.length; i += 1) {
          const currentChild = item.items[i];
          const result = this.helper_findCubeStructure(currentChild);
          if (result !== false) {
            return result;
          }
        }
    }
    return false;
  }

  isTemplateHierarchy = () => {
    const {
      navigationLookupResult
    } = this.props;

    const dataModelsObj = navigationLookupResult?.navigationLookupBuckets["Data Models"];
    return dataModelsObj && dataModelsObj?.objects?.length > 0 && 
      dataModelsObj.objects.some(dataModel => dataModel.cubeHierarchyType === DATAMODELS_TYPES.TEMPLATE_HIERARCHY)
  }

  static contextType = StoreContext;
  render() {
    const {
      cubeQueryWizardStore,
      navigationLookupResult,
      searchMatrixKey,
      otherInformation,
    } = this.props;

    const { handleIndividualCubeViewExport } = this.props.exportImportStore;

    const { fetchingDataStatus } = this.context;

    let dataSetDistributions = [];
    if (otherInformation && otherInformation.dataSetDistributions) {
      dataSetDistributions = otherInformation.dataSetDistributions;
    }

    // render this view only for Cubes, ignore for others
    if (navigationLookupResult.params.type !== "Cube") {
      return null;
    }

    let cubeStructure = null;
    let cubeDetails = null;
    let hasCombinations = false;

    if (
      navigationLookupResult &&
      navigationLookupResult.navigationLookupRootItem
    ) {
      const rootItem = navigationLookupResult.navigationLookupRootItem;
      cubeStructure = this.helper_findCubeStructure(rootItem);
      cubeDetails = [navigationLookupResult.navigationLookupRootItem.object];
    }

    if (
      navigationLookupResult &&
      navigationLookupResult.navigationLookupBuckets &&
      navigationLookupResult.navigationLookupBuckets["Combinations"] &&
      navigationLookupResult.navigationLookupBuckets["Combinations"]
        .totalCountOfObjects > 0
    ) {
      hasCombinations = true;
    }

    // if it has TR, it must also have combinations:
    hasCombinations =
      hasCombinations || cubeQueryWizardStore.hasTemplateRepresentation;

    const dimensions = cubeStructure?.items?.filter(
      (item) => item.object.role.toLowerCase() === "d"
    );
    const observations = cubeStructure?.items?.filter(
      (item) => item.object.role.toLowerCase() === "o"
    );
    const attributes = cubeStructure?.items?.filter(
      (item) => item.object.role.toLowerCase() === "a"
    );

    const searchExpr = this.context.getSearchMatrix[searchMatrixKey] || "";
    const isLoading = fetchingDataStatus.get("CubeStructure") === true;

    if ((!cubeStructure || !cubeStructure.items) && !isLoading) return null;
    return (
      <div className="related-objects custom-panel" ref={this.props?.innerRef}>
        <div className="custom-panel-heading">
          <h4>Cube Representation</h4>
          {isLoading ? (
            <>
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="custom-export-alignament"></div>
            </>
          ) : (
            <div className="custom-export-alignament">
              <h5> Excel export</h5>
              <button
                className="glyphicon glyphicon-download-alt"
                style={{
                  float: "right",
                  cursor: "pointer",
                  background: "none",
                  border: "none",
                  marginLeft: "10px",
                  padding: 0,
                }}
                onClick={() =>
                  handleIndividualCubeViewExport(this.props.object)
                }
                aria-label="Export to Excel"
              ></button>
            </div>
          )}
        </div>

        {!!cubeStructure && !!cubeStructure.items && !isLoading ? (
          <>
            <div className="custom-panel-body related-types-list">
              <ListSearch
                searchMatrixKey={searchMatrixKey}
                placeholder={"Filter by Name or Code of the field"}
              />
              <Grid className="cube-structure-item" fluid={true}>
                <Row>
                  <Col xs={6}>
                    <h5 style={{ marginLeft: "10px" }}>
                      <b>Attributes</b>
                    </h5>
                  </Col>
                  <Col xs={6}>
                    <h5>
                      <b>With values restricted to</b>
                    </h5>
                  </Col>
                </Row>
              </Grid>
              {dimensions && dimensions.length ? (
                <CubeRoleGroup
                  type="d"
                  items={dimensions}
                  searchExpr={searchExpr}
                />
              ) : null}
              {observations && observations.length ? (
                <CubeRoleGroup
                  type="o"
                  items={observations}
                  searchExpr={searchExpr}
                />
              ) : null}
              {attributes && attributes.length ? (
                <CubeRoleGroup
                  type="a"
                  items={attributes}
                  searchExpr={searchExpr}
                />
              ) : null}
            </div>
            <CubeQueryWizard
              cubeRootItem={navigationLookupResult.navigationLookupRootItem}
              cubeDetails={cubeDetails}
              hasCombinations={hasCombinations}
              dataSetDistributions={dataSetDistributions}
              otherInformation={otherInformation}
              isTemplateHierarchy={this.isTemplateHierarchy()}
            />
          </>
        ) : (
          ""
        )}
      </div>
    );
  }
}
